import * as React from 'react';
import { History } from 'history';
import Model from './menugroup-model';
import BasePicklistCard from '../base/base-picklistcard.component';
import AppService from '../../services/app.service';

interface IProps {
  history: History;
  root?: string;
  caption?: string;
  currentId?: number;
  cardCount?: number;
  cardIconOnly?: boolean;
  autoLoad?: boolean;
  onLoad?: (data: any) => void;
  disableBackButton?: boolean;
}

interface IState {
  datarow: Model;
  currentId: number;
}

export default class MenugroupPicklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { 
      datarow: Model.defaultValue(),
      currentId : this.props.currentId || 0,
    }
  }

  private isMobile: boolean = AppService.isMobile();
  
  private onLoad = (data: any) => {
    const historyState = AppService.historyState();
    this.props.history.push(this.props.history.location.pathname, {...historyState, menugroupId: data.id, menugroupCaption: data.name});
    this.setState({datarow: data, currentId: data.id})
    this.props.onLoad?.(data);
  }

  public render(): React.ReactNode {
    return (
      <BasePicklistCard history={this.props.history} caption={this.props.caption} endPointFilter={Model.endPointFilterList2()} model={Model} currentId={this.state.currentId} onLoad={this.onLoad} pageSize={this.isMobile? 6: 10} cardCount={this.props.cardCount || 2} cardRightArrow swipe={this.isMobile? 'vertical' : ''} cardIconOnly={this.props.cardIconOnly} autoLoad={this.isMobile || this.props.autoLoad} searchField=' ' disableBackButton={this.props.disableBackButton} disableCard/>
    );
  }
}
